import React from 'react';

import { useTranslate } from 'hooks/useTranslations';
import { AlertMessage } from 'ui/elements/AlertMessage';

export const RestrictedProductMessage: React.FC<{
  plural: boolean;
  largeIcon?: boolean;
  dataTestId?: string;
}> = ({ plural = false, dataTestId }) => {
  const t = useTranslate();

  const message = plural
    ? t('productsCannotBeShippedToYourState')
    : t('productCannotBeShippedToYourState');

  return (
    <AlertMessage
      type="warning"
      icon="exclamation-outline"
      dataTestId={dataTestId}
    >
      {message}
    </AlertMessage>
  );
};
